import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';

const Footer = () => {
  return (
    <footer className="bg-ninsun-surface border-t border-white/5 py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <Link 
              to="/" 
              className="flex items-center space-x-3 mb-4 md:mb-6 hover:opacity-90 transition-opacity"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 border border-gray-200 rounded-lg flex items-center justify-center overflow-hidden shadow-sm bg-white">
                <img src={logo} alt="Ninsun Biotech Logo" className="w-full h-full object-cover"/>
              </div>
              <span className="text-xl md:text-2xl font-bold font-display tracking-tight text-[#D4AF37]">Ninsun Biotech</span>
            </Link>
            <p className="text-ninsun-muted text-sm md:text-base leading-relaxed">
              We provide the missing piece for optimal treatment decision-making in oncology.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-bold tracking-widest text-ninsun-text uppercase mb-4 md:mb-6">Technology</h4>
            <ul className="space-y-2 md:space-y-3 text-ninsun-muted">
              <li><a href="#technology" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Our Technology</a></li>
              <li><a href="#clinical" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Clinical Validation</a></li>
              <li><a href="#workflow" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Routine Assay</a></li>
              <li><a href="#therapeutics" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Drug Development</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold tracking-widest text-ninsun-text uppercase mb-4 md:mb-6">Company</h4>
            <ul className="space-y-2 md:space-y-3 text-ninsun-muted">
              <li><a href="#mission" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Our Mission</a></li>
              <li><a href="#team" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">Team</a></li>
              <li><a href="#news" className="hover:text-ninsun-gold transition-colors text-sm md:text-base">News</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold tracking-widest text-ninsun-text uppercase mb-4 md:mb-6">Contact</h4>
            <div className="space-y-2 md:space-y-3 text-ninsun-muted text-sm md:text-base">
              <p className="break-all font-mono"><a href="mailto:contact@ninsun-biotech.com" className="hover:text-ninsun-gold">contact@ninsun-biotech.com</a></p>
              <p className="leading-relaxed">
                Ninsun Biotech is based at the BioArk,<br />
                Route de l'Ile-au-Bois 1A,<br />
                1870 Monthey, Valais, Switzerland<br />
                Supported by the <a href="https://bioark.ch/" target="_blank" rel="noreferrer" className="text-ninsun-gold hover:underline">Fondation The Ark</a>.
              </p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 mt-10 md:mt-16 pt-8 text-center text-ninsun-muted">
          <p className="text-xs md:text-sm font-mono tracking-wide">&copy; {new Date().getFullYear()} Ninsun Biotech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;